import { ReduxHelper } from "helpers";
import { ICreatePalletsRequest, IPallet } from "model";

export const prefix = "PRODUCT";

export const createPallets = ReduxHelper.generateActions<
  ICreatePalletsRequest,
  IPallet[]
>(prefix, "GET_ALL_PRODUCTS");

export const clearAction = ReduxHelper.generateLocalAction(
  prefix,
  "CLEAR_ACTION"
);
